










import { computed, defineComponent, PropType } from "@vue/composition-api";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import { timeAgo } from "@/lib/time";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "TransactionMoneyDate",
  components: { FormatMoney },
  props: {
    transaction: { type: Object as PropType<Transaction>, required: true },
  },
  setup(props) {
    const date = computed(() => timeAgo(props.transaction.time));
    const isPositive = computed(() => props.transaction.amount > 0);

    return { date, isPositive };
  },
});
